import { TranslationsContext } from '@teliaee/telia-translate';
import {
  Autoscroll,
  Button,
  Container,
  Grid,
  GridColumn,
  Heading,
  Modal,
  ModalProvider,
  ModalTrigger,
  Notice,
  Separator,
  Text,
  Section
} from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import config from '../../config';
import RoamingStore from '../../stores/RoamingStore';
import LoginButton from '../../sso/LoginButton';
import GaHelper from '../../util/GaHelper';

interface EeaCountryCardProps {
  isoCode: string;
  roamingStore?: RoamingStore;
}

@observer
class EeaCountryCard extends React.Component<EeaCountryCardProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public render() {
    const { translate } = this.context;
    return (
      <Section backgroundColor="neutral-bg-level-2" isFull>
        <Container>
          <Text className="text-center">
            <Heading element="h2">{this.getHeaderText()}</Heading>
            <p>{translate('roaming.country.eea.sub.header')}</p>
            <LoginButton
              className="text__margin-double"
              text={translate('roaming.country.eea.selfservice-button.text')}
              iconRight="#arrow-right"
              url={`${config.diil.selfServiceUrl}${config.diil.volumesPageInSelfService}`}
              target="_blank"
              submitDataGa={{ eventCategory: 'Hinnad välismaal', eventAction: 'Additional information', eventLabel: 'Link - Self-Service' }}
            />
            <Separator spacing="small" color="invisible" />
            <Grid align={['center-xs']}>
              <GridColumn width={['md-7']}>
                <Notice size="small">
                  <div>
                    {translate('roaming.country.eea.notice.pricing.text')} {this.getPricingButton()}.<br />
                    {translate('roaming.country.eea.notice.text')}
                  </div>
                </Notice>
                <Separator spacing="small" color="invisible" />
                <ModalProvider>
                  <ModalTrigger>
                    <Button
                      className="text__margin-double"
                      text={translate('roaming.country.eea.show-countries.button.text')}
                      link={true}
                      onClick={() =>
                        GaHelper.pushGaData({
                          eventCategory: 'Hinnad välismaal',
                          eventAction: 'Additional information',
                          eventLabel: 'Link - Vaata riike, kus kehtivad Eesti hinnad ja tingimused'
                        })
                      }
                    />
                  </ModalTrigger>
                  <Modal>
                    <Grid align={['center-xs']}>
                      <GridColumn width={['md-6']}>
                        <Text className="text-center">
                          {this.getEeaCountryList()} <br />
                          <br />
                          {translate('roaming.country.eea.no-internet.text')}
                          <br />
                          {translate('roaming.country.eea.no-internet.list')}
                        </Text>
                      </GridColumn>
                    </Grid>
                  </Modal>
                </ModalProvider>
              </GridColumn>
            </Grid>
          </Text>
        </Container>
      </Section>
    );
  }

  private getHeaderText() {
    const translate = this.context.translate;
    const { isoCode, roamingStore } = this.props;
    if (roamingStore.isMobileInternetCountry()) {
      return translate('roaming.country.eea.main.header.text', { countryName: translate(`roaming.country.eea.main.header.${isoCode}`) });
    }
    return translate('roaming.country.eea.no-internet.main.header.text', { countryName: translate(`roaming.country.eea.main.header.${isoCode}`) });
  }

  private getEeaCountryList() {
    return this.props.roamingStore.countryList.countries
      .filter((country) => {
        return country.eea;
      })
      .map((country) => country.name)
      .join(', ');
  }

  private getPricingButton() {
    const translate = this.context.translate;
    return (
      <Autoscroll
        id="operators"
        speed={1000}
        offset={150}
        onClick={() =>
          GaHelper.pushGaData({
            eventCategory: 'Hinnad välismaal',
            eventAction: 'Additional information',
            eventLabel: 'Link - Hinnakiri'
          })
        }
      >
        <Button text={translate('roaming.country.eea.notice.pricing.button')} link={true} />
      </Autoscroll>
    );
  }
}

export default inject('roamingStore')(EeaCountryCard);
